export const InputBaseStyle = {
  field: {
    outline: 0,
    lineHeight: '142.857%',
    letterSpacing: '-0.084px',
    bg: 'white',
    color: 'text.input',
    _placeholder: {
      color: 'text.placeholder'
    },
    _readOnly: {
      userSelect: 'all'
    }
  }
};

export const InputVariants = {
  outline: {
    field: {
      borderWidth: '1px',
      borderColor: 'border.input.outline',
      bg: 'white',
      boxShadow: '0px 1px 2px 0px rgba(228, 229, 231, 0.24)',
      _focus: {
        
      },
      
    }
  }
};

export const InputSizes = {
  md: {
    group: {
      h: '40px',
    },
    element: {
      h: '40px',
    },
    field: {
      h: '40px',
      borderRadius: '10px',
      fontSize: '14px',
    }
  },
  sm: {
    group: {
      h: '36px',
    },
    element: {
      h: '36px',
    },
    field: {
      h: '36px',
      borderRadius: '8px',
      fontSize: '14px',
    }
  }
};

const Input = {
  baseStyle: InputBaseStyle,
  variants: InputVariants,
  sizes: InputSizes,
  defaultProps: {
    colorScheme: false,
    variant: 'outline'
  }
};

export default Input;
